module.exports = __webpack_public_path__ + "media/images/pic/testimonials/blank-47be06e3c04f10b9d270fee13a50b0a8.webp";